export const INTEGRATED_SHELL_PATH = "/integrated";
export const INTEGRATED_HOME_STYLE_PATH = `${INTEGRATED_SHELL_PATH}/home-style`;
export const INTEGRATED_CONSTRUCTION_PATH = `${INTEGRATED_SHELL_PATH}/construction`;
export const CONSTRUCTION_PROJECT_CONTEXT_CHANGE_EVENT = "project-selmo:construction-project-context-change";

export type IntegratedWorkspaceId = "home-style" | "construction";

const CONSTRUCTION_PROJECT_CONTEXT_PARAM = "constructionProject";
const MAX_PROJECT_CONTEXT_LENGTH = 200;

function normalizedProjectContext(value: string | null | undefined): string | undefined {
  const normalized = value?.trim();
  if (!normalized || normalized.length > MAX_PROJECT_CONTEXT_LENGTH) return undefined;
  return normalized;
}

export function isIntegratedShellPath(pathname: string): boolean {
  return pathname === INTEGRATED_SHELL_PATH || pathname.startsWith(`${INTEGRATED_SHELL_PATH}/`);
}

export function integratedWorkspaceFromLocation(
  pathname: string,
  hash = "",
): IntegratedWorkspaceId {
  if (pathname === INTEGRATED_CONSTRUCTION_PATH
    || pathname.startsWith(`${INTEGRATED_CONSTRUCTION_PATH}/`)) {
    return "construction";
  }
  if (pathname === INTEGRATED_HOME_STYLE_PATH
    || pathname.startsWith(`${INTEGRATED_HOME_STYLE_PATH}/`)) {
    return "home-style";
  }

  // 이전 파일럿 주소(`/integrated#/construction`)도 새 보호 경로로 옮길 수 있게
  // 루트 경로에서만 과거 해시를 해석합니다. 새 시공 화면의 해시는 시공 작업공간이 전용으로 사용합니다.
  const legacyRoute = hash.replace(/^#\/?/, "").split("?")[0];
  return legacyRoute === "construction" ? "construction" : "home-style";
}

export function integratedWorkspaceHref(workspace: IntegratedWorkspaceId): string {
  return workspace === "construction"
    ? INTEGRATED_CONSTRUCTION_PATH
    : INTEGRATED_HOME_STYLE_PATH;
}

export function constructionProjectIdFromHash(hash = ""): string | undefined {
  const [route, query = ""] = hash.replace(/^#\/?/, "").split("?");
  if (route !== "projects" && route !== "construction") return undefined;
  return normalizedProjectContext(new URLSearchParams(query).get("project"));
}

export function homeStyleConstructionProjectContext(search = ""): string | undefined {
  const query = search.startsWith("?") ? search.slice(1) : search;
  return normalizedProjectContext(new URLSearchParams(query).get(CONSTRUCTION_PROJECT_CONTEXT_PARAM));
}

export function homeStyleWorkspaceHrefForConstructionHash(hash = "", search = ""): string {
  const query = search.startsWith("?") ? search.slice(1) : search;
  const currentParams = new URLSearchParams(query);
  const params = new URLSearchParams();
  const screen = currentParams.get("screen");
  if (screen === "registration") params.set("screen", screen);
  const projectId = constructionProjectIdFromHash(hash);
  if (projectId) params.set(CONSTRUCTION_PROJECT_CONTEXT_PARAM, projectId);
  const encoded = params.toString();
  return `${integratedWorkspaceHref("home-style")}${encoded ? `?${encoded}` : ""}`;
}

export function constructionProjectWorkspaceHref(projectId?: string): string {
  const normalized = normalizedProjectContext(projectId);
  if (!normalized) return "/#/projects";
  const params = new URLSearchParams({ project: normalized, tab: "quotes" });
  return `/#/projects?${params.toString()}`;
}
